import { render, staticRenderFns } from "./soft_limit_reached_modal.vue?vue&type=template&id=b1ed46ba&"
import script from "./soft_limit_reached_modal.vue?vue&type=script&lang=js&"
export * from "./soft_limit_reached_modal.vue?vue&type=script&lang=js&"
import style0 from "./soft_limit_reached_modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports